import { MessageOffset, WidgetId, WidgetStateId } from './aliases';
import { PaperFinderWidgetAction } from './widget-actions';
import { RoundStatus } from './widget-state';

export interface User {
  id: string;
  displayName: string;
}

export interface TextMessage {
  text: string;
  kind: 'natural-language';
  sender: User;
  offsetInThread: MessageOffset;
}

export interface WidgetActionMessage {
  kind: 'action';
  action: PaperFinderWidgetAction;
  sender: User;
  offsetInThread: MessageOffset;
  predecessorOffsetInThread: MessageOffset;
}

export interface StateUpdateMessage {
  kind: 'widget-state-update';
  widgetId: WidgetId;
  status: RoundStatus['kind'];
  stateId: WidgetStateId;
  offsetInThread: MessageOffset;
  predecessorOffsetInThread: MessageOffset;
  prevStateOffsetInThread: MessageOffset | null;
  nextStateOffsetInThread: MessageOffset | null;
}

export type Message = TextMessage | StateUpdateMessage | WidgetActionMessage;
export type ClientMessage = TextMessage | WidgetActionMessage;

export function isStateUpdateMessage(m: Message): m is StateUpdateMessage {
  return m.kind === 'widget-state-update';
}

export function isTextMessage(m: Message): m is TextMessage {
  return m.kind === 'natural-language';
}

export function isActionMessage(m: Message): m is WidgetActionMessage {
  return m.kind === 'action';
}

export interface Thread {
  id: string;
  messages: Array<Message>;
  createdTimestamp: number;
}
